<template>
  <div>
    <ul class="m-list">
      <li class="m-item" v-for="(item,index) in dataList" :key="index">
        <em :class="{'em-active':activeIndex === index+1}">{{index + 1}}</em>
        <span :class="{'span-active':activeIndex === index+1}">{{item.name}}</span>
        <i v-if="index<dataList.length-1">—</i>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    dataList: {
      type: Array,
      default: []
    },
    activeIndex: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data () {
    return {
      msg: '你好'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
.m-list {
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding: 0 25px;
  font-size: 14px;
  .m-item {
    display: inline-block;
    color: #999999;
    > em {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      border: 1px solid #999999;
      border-radius: 50%;

    }
    .em-active {
      background-color: #666666 !important;
      border-color: #666666;
      color: #ffffff !important;
    }
    > span {
      line-height: 20px;
      padding-left: 6px;
    }
    .span-active {
      color: #666666;
    }
    > i {
      padding: 0 10px;
    }
  }
}
</style>
